
import { defineComponent, reactive, ref } from 'vue';
import QRCodeReader from '@/components/molecules/QRCodeReader.vue';

export default defineComponent({
  name: 'DialogQRCodeReader',

  components: {
    QRCodeReader,
  },

  setup(_, { emit }) {
    const dialog = ref(false);

    /**
     * @public
     */
    const open = () => {
      dialog.value = true;
    };

    const state = reactive<{ result: any }>({
      result: undefined,
    });

    const onDecode = (result: string) => {
      state.result = result;
      emit('decoded', result);
      dialog.value = false;
    };

    return {
      // dialog
      dialog,
      open,

      state,
      onDecode,
    };
  },
});
